var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStabenfeldt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 175 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#9ea0a0;fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Homepage-new-section"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Microtica-2021_-HomePage-v1",
    "data-name": "[Microtica-2021]-HomePage-v1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-46-Copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-45"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    className: "cls-1",
    d: "M0,22.62c2.22,2.22,4.17,3.89,7.5,3.89A7.24,7.24,0,0,0,15,19.28C15,11,4.17,13.17,4.17,8.45A3.5,3.5,0,0,1,7.78,4.84c1.94,0,3.33,1.39,4.44,2.5l2.22-2.22A8.54,8.54,0,0,0,7.78,1.51C3.33,1.51.28,4.28.28,8.45c0,8.33,10.83,5.28,10.83,10.83,0,3.06-1.94,4.17-4.44,4.17a5.52,5.52,0,0,1-4.45-2.78Z",
    transform: "translate(0 -0.51)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    className: "cls-1",
    d: "M27.2,7.55H22.9v-5l-3.22.56v4.2H18.07L17,10.36h2.68v9.82a5.06,5.06,0,0,0,5.1,5.33h2.68L28,22.42c-.8,0-1.34.28-2.15.28-2.41,0-3-.56-3-2.8V10.36h4.56V7.55Z",
    transform: "translate(0 -0.51)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    className: "cls-1",
    d: "M43,25.23V14.05c0-4.63-2.26-6.54-7.08-6.54-1.69,0-3.67.54-4.81.54l-.85,3.27a12.45,12.45,0,0,1,5.1-1.09c2.55,0,4.24.28,4.24,2.73v1.36a6.56,6.56,0,0,0-4.52-1.63c-3.68,0-7.08,2.18-7.08,6s2.55,6.82,6.51,6.82c2.26,0,4.24-.55,5.38-2.46v2.46ZM35.36,16c2,0,4.24,1.09,4.24,3.27,0,2.73-2,3.55-4.24,3.55-2.55,0-4-1.09-4-3.55S33.38,16,35.36,16Z",
    transform: "translate(0 -0.51)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    className: "cls-1",
    d: "M47.27,17.36a8.32,8.32,0,0,0,8.46,8.15C61.18,25.51,65,21.57,65,16a9,9,0,0,0-8.73-9.27,7.29,7.29,0,0,0-6,2.8v-9L47,1.07V17.36Zm3-1.12a6.15,6.15,0,0,1,6-6.18A5.92,5.92,0,0,1,62,16.24a5.92,5.92,0,0,1-5.73,6.18C52.73,22.7,50.27,19.89,50.27,16.24Z",
    transform: "translate(0 -0.51)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    "data-name": "Shape",
    className: "cls-1",
    d: "M84,12.33c-2-3.12-4.25-4.82-7.93-4.82A9.32,9.32,0,0,0,67,16.58c0,5.67,3.68,9.93,9.63,9.93,2.84,0,4.82-1.14,7.09-2.84L83.15,20c-1.7,1.42-4.25,3.12-6.52,3.12a5.83,5.83,0,0,1-4.81-2.83Zm-13.6,5.1c-.28-3.69,2-6.8,5.67-6.8a4.25,4.25,0,0,1,3.11,1.13Z",
    transform: "translate(0 -0.51)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    "data-name": "Path",
    className: "cls-1",
    d: "M91.43,25.94V16c0-4,2.28-5.38,5.14-5.38,2,0,4,.85,4,3.4V26.51l3.43-.57V13.74c0-4.53-3.43-6.23-7.14-6.23a6.66,6.66,0,0,0-5.43,2.55V7.51L88,8.07V26.51Z",
    transform: "translate(0 -0.51)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-4",
    "data-name": "Path",
    className: "cls-1",
    d: "M107.26,26.51l3.38-.57V11.06h4.51V8.25h-4.51c0-2.81,1.13-3.93,3.67-3.93A3.59,3.59,0,0,1,116,4.6l-1.13-3.09c-4.79,0-7.9,1.68-7.61,7h-1.41L105,11.62h2.26Z",
    transform: "translate(0 -0.51)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-4",
    "data-name": "Shape",
    className: "cls-1",
    d: "M133,12.33c-2-3.12-4.25-4.82-7.93-4.82A9.32,9.32,0,0,0,116,16.58c0,5.67,3.68,9.93,9.35,9.93,2.83,0,4.82-1.14,7.08-2.84L131.87,20c-1.7,1.42-4.25,3.12-6.52,3.12a5.86,5.86,0,0,1-4.82-2.83Zm-13.6,5.1c-.28-3.69,2-6.8,5.67-6.8a4.25,4.25,0,0,1,3.11,1.13Z",
    transform: "translate(0 -0.51)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-5",
    "data-name": "Path",
    className: "cls-1",
    points: "140 24.72 140 0 137 0.56 137 25 140 24.72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-5",
    "data-name": "Shape",
    className: "cls-1",
    d: "M158,26.23l3-.28V1.51l-3.27.55v8.33a9.78,9.78,0,0,0-6-2.5A8.61,8.61,0,0,0,143,17.06c0,5,3.82,9.45,8.72,9.45A8.09,8.09,0,0,0,158,23.45Zm.27-9.17c0,3.89-2.72,6.11-6.26,6.11-3.27,0-5.73-3.05-5.73-6.11A5.89,5.89,0,0,1,152,11,6,6,0,0,1,158.27,17.06Z",
    transform: "translate(0 -0.51)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-6",
    "data-name": "Path",
    className: "cls-1",
    d: "M174.46,7.49H169.9v-5l-3.22.83V7.49h-1.61l-1.07,3h2.68v9.7a5,5,0,0,0,5.1,5.27h2.68l.54-3.05c-.8,0-1.34.28-2.15.28-2.41,0-2.95-.56-2.95-2.78V10.27h4.56Z",
    transform: "translate(0 -0.51)"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStabenfeldt);
export default __webpack_public_path__ + "static/media/stabenfeldt.5c00918f28cf9b959104b2962ef34a84.svg";
export { ForwardRef as ReactComponent };